'use strict';

export default class PagePrendreUnRdv {
  constructor(options) {
    console.log('PagePrendreUnRdv component');

    const defaults = {
        inputToBeDate: '#edit-field-date-souhaitee'
    };

    this.options = Object.assign({}, defaults, options);

    //auto init
    this._setupInputDate();
    this._copyInputValue();

  }

  _setupInputDate() {
    // $(this.options.inputToBeDate).attr('type', 'date');
  }

  _copyInputValue() {
    $("[name='establishment_email']").attr('value', $("[name='establishment_email_fake']").val());
  }

}
